"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTextFieldLogic = void 0;
const field_logic_1 = require("../../field-type-registry/field-logic");
const fields_1 = require("../../utils/fields");
const base_text_fieldtype_1 = require("../../safe-field-value/text-fields/base-text.fieldtype");
class BaseTextFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor(config, appRecordsService) {
        super(config, appRecordsService);
        // properties that we load from backend
        this.leadingZerosLen = 4;
        this.leadingZeros = "".padStart(this.leadingZerosLen, "0");
        this.fieldValueGetter = new base_text_fieldtype_1.BaseTextFieldValueGetter();
        this.defaultMaxLength = config.default_max_length;
    }
    canChangeValue(field, fromValue, toValue) {
        var _a;
        const allowedMaxLength = !toValue || (!!toValue && ((_a = (0, fields_1.getMaxLength)(field)) !== null && _a !== void 0 ? _a : 0) >= toValue.length);
        return allowedMaxLength && super.canChangeValue(field, fromValue, toValue);
    }
}
exports.BaseTextFieldLogic = BaseTextFieldLogic;
